

























import { Component, Ref, Vue } from "vue-property-decorator";
import { readEntriesArray, readFLCID } from "@/store/uniabc/getters";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchLoadEntries } from "@/store/uniabc/actions";
import {
  dispatchRaiseErrorTimeout,
  dispatchResetUnsavedChangesState
} from "@/store/appState/actions";
import MitigateFailedCommit from "@/components/repository/MitigateFailedCommit.vue";

@Component({
  components: { MitigateFailedCommit }
})
export default class CommitEntries extends Vue {
  private commitMessage = "";
  private entries = readEntriesArray(this.$store)();

  @Ref() readonly mitigationDialog!: MitigateFailedCommit;

  private async doCommit(mitigation: boolean) {
    if (this.entries.length > 0) {
      try {
        await api.postCommitUniAbc(
          readGitLabInfo(this.$store),
          this.entriesJSON,
          this.commitMessage,
          readFLCID(this.$store)
        );
        this.commitMessage = "";
        await dispatchResetUnsavedChangesState(this.$store);
        await dispatchLoadEntries(this.$store);
      } catch (e) {
        await dispatchRaiseErrorTimeout(
          this.$store,
          mitigation
            ? new Error(
                `Error while pushing the commit, starting Mitigation:<br>${e}`
              )
            : new Error(
                `Error while performing Mitigation. Please download the JSON-File and perform mitigation manually.<br> Error: ${e}`
              )
        );

        if (!mitigation) this.startMitigation();
      }
    } else {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error("Nothing to commit: No entries exist.")
      );
    }
  }

  private startMitigation() {
    this.mitigationDialog.openMitigation();
  }

  private mounted() {
    // console.info(this.entries);
  }

  get entriesJSON() {
    return JSON.stringify(this.entries, null, 4);
  }
}
